export default {
  banner: {
    description:
      "Obtenez {{range}} de remise en commandant via l'application FoodAmigos gratuite. Cliquez ici pour télécharger →",
  },
  labels: {
    deals: 'Offres',
    collecting_points: 'Vous collectez déjà des points ?',
    earn_points: 'Gagnez des points & obtenez des récompenses ',
    order_again: 'Commander à nouveau',
  },
  checkout_button: {
    title: 'Voir le panier',
  },
};
